import { useMutation, useQueryClient } from '@tanstack/react-query'
import adminAuthService from './admin-auth.service'
import type {
  AdminCreateEmailOTPInput,
  AdminCreateOTPInput,
  AdminLoginByEmailInput,
  AdminLoginByPhoneInput,
  AdminRefreshTokenInput,
} from '../api'

export const useAdminLoginByEmail = () => {
  return useMutation({
    mutationFn: (data: AdminLoginByEmailInput) =>
      adminAuthService.adminLoginByEmail(data),
  })
}

export const useAdminLoginByPhone = () => {
  return useMutation({
    mutationFn: (data: AdminLoginByPhoneInput) =>
      adminAuthService.adminLoginByPhone(data),
  })
}

export const useAdminAuthRefresh = () => {
  return useMutation({
    mutationFn: (data: AdminRefreshTokenInput) =>
      adminAuthService.adminAuthRefresh(data),
  })
}

export const useAdminLogout = () => {
  const queryClient = useQueryClient()
  const clearCache = () => {
    queryClient.clear()
  }
  return { clearCache }
}

export const useAdminEmailOtp = () => {
  return useMutation({
    mutationFn: (data: AdminCreateEmailOTPInput) =>
      adminAuthService.createAdminEmailOtp(data),
  })
}

export const useAdminPhoneOtp = () => {
  return useMutation({
    mutationFn: (data: AdminCreateOTPInput) =>
      adminAuthService.createAdminPhoneOtp(data),
  })
}
